import API from '@/shared/plugins/Api/API'
import Applications from './Applications'
import Modules from './Modules'
import AppServiceV3 from './v3'

class APPSERVICE extends API {
  constructor (id) {
    super(id)
    this.applications = new Applications(id)
    this.modules = new Modules(id)
    this.v3 = new AppServiceV3(id)
  }

  async sshPublic () {
    const data = await this.request({
      url: 'ssh/public'
    })
    return data.public
  }

  async fetchRepoBranches (repository) {
    const data = await this.request({
      url: 'repo/git',
      params: repository
    })
    return data.branches
  }

  async configurationList () {
    return await this.request({
      url: 'configuration/list'
    }).then(data => data.results)
  }
}
export default APPSERVICE
